import { useContext, useEffect, useState } from "react";
import { PaymentRequest } from "../App";

const useBuyNowPaymentMethod = () => {
  const paymentRequest = useContext(PaymentRequest);

  const [buyNowPaymentMethod, setBuyNowPaymentMethod] = useState();

  useEffect(() => {
    if (paymentRequest) {
      paymentRequest.on('paymentmethod', async (event) => {
        setBuyNowPaymentMethod(event.paymentMethod);
      });
    }
  }, [paymentRequest]);

  return buyNowPaymentMethod
}

export default useBuyNowPaymentMethod;
